module.exports = __webpack_public_path__ + "static/media/43.42ae1871.png";